import { render, staticRenderFns } from "./AllProduct.vue?vue&type=template&id=3d1cc347&"
import script from "./AllProduct.vue?vue&type=script&lang=js&"
export * from "./AllProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports